
import { ICategory } from 'src/app/models/commerce/category.model';
import * as fromCategoriesCommerce from './commerce-category.action';

export interface categoriesCommerceState {
    categories: ICategory[];
}

const estadoInicial: categoriesCommerceState = {
    categories: []
};


export function categoriesCommerceReducer(state = estadoInicial, action: fromCategoriesCommerce.acciones): categoriesCommerceState {

    switch (action.type) {

        case fromCategoriesCommerce.SET_CATEGORIES_COMMERCE:
            return {
                ...state,
                categories: action.categories
            };

        case fromCategoriesCommerce.UNSET_CATEGORIES_COMMERCE:
            return {
                categories: []
            };

        default:
            return state;

    }

}
